import { calcColorGradient } from "./calcColorGradient";

export const DEFAULT_STATE = {
  Color: {
    Primary: {
      color: "Primary",
      pickedColor: "#fff",
      gradientOptions: calcColorGradient("#ffffff"),
    },
    Secondary: {
      color: "Secondary",
      pickedColor: "#fff",
      gradientOptions: calcColorGradient("#ffffff"),
    },
    Tertiary: {
      color: "Tertiary",
      pickedColor: "#fff",
      gradientOptions: calcColorGradient("#ffffff"),
    },
    Success: {
      color: "Success",
      pickedColor: "#fff",
      gradientOptions: calcColorGradient("#ffffff"),
    },
    Danger: {
      color: "Danger",
      pickedColor: "#fff",
      gradientOptions: calcColorGradient("#ffffff"),
    },
    Warning: {
      color: "Warning",
      pickedColor: "#fff",
      gradientOptions: calcColorGradient("#ffffff"),
    },
    Info: {
      color: "Info",
      pickedColor: "#fff",
      gradientOptions: calcColorGradient("#ffffff"),
    },
  },
};
